import { Draggable, Droppable } from '@hello-pangea/dnd';

import { RfdDragIslandProvider } from '@src/providers/RfdDragIslandContext';
import { PredictionCard } from './PredictionCard/PredictionCard';
import { DragWrapper, DropZone, Filler } from './styles';

import {
  filterBySubstring,
  MixpanelEventSource,
  MixpanelSourceContext,
  type PredictionMarketCardConfig,
} from '@talos/kyoko';

interface PredictionMarketDroppableContainerProps {
  columnIndex: number;
  cardFilter: string;
  cards: PredictionMarketCardConfig[];
  disableDrag: boolean;
  lastColumnIndex: number;
  deleteCard: (card: PredictionMarketCardConfig) => void;
  saveCard: (card: PredictionMarketCardConfig) => void;
  hidePlaceholders: () => void;
}

export function PredictionMarketDroppableContainer({
  columnIndex,
  cardFilter,
  cards,
  disableDrag,
  lastColumnIndex,
  deleteCard,
  saveCard,
  hidePlaceholders,
}: PredictionMarketDroppableContainerProps) {
  const filteredCards = filterBySubstring(cards, cardFilter, ['eventTitle', 'eventSymbol', 'outcomeSymbol']);

  return (
    <Droppable droppableId={`${columnIndex}`}>
      {provided => (
        <DropZone
          ref={provided.innerRef}
          {...provided.droppableProps}
          data-testid={`prediction-market-droppable-column-${columnIndex}`}
        >
          {filteredCards.map((card, index) => (
            <Draggable isDragDisabled={disableDrag} key={card.id} draggableId={card.id} index={index}>
              {(provided, snapshot) => (
                <DragWrapper
                  ref={provided.innerRef}
                  data-testid={`prediction-market-card-drag-wrapper-${card.id}`}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  <MixpanelSourceContext.Provider value={MixpanelEventSource.MarketCard}>
                    <RfdDragIslandProvider dragHandleProps={provided.dragHandleProps}>
                      <PredictionCard
                        config={card}
                        isDragged={snapshot.isDragging}
                        isDraggable={!disableDrag}
                        onDelete={deleteCard}
                        onSave={saveCard}
                        onHidePlaceholders={hidePlaceholders}
                      />
                    </RfdDragIslandProvider>
                  </MixpanelSourceContext.Provider>
                </DragWrapper>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
          {cards.length === 0 && columnIndex <= lastColumnIndex && <Filler />}
        </DropZone>
      )}
    </Droppable>
  );
}
